import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BrandFilterType } from '../../../../models/Filters';
import { resources } from '../../../../resources/resources';
import { CheckboxFilter } from '../Common/CheckboxFilter';
import { mapToBrandFilterItems } from '../helpers';

interface BrandFilterProps {
  brandList: BrandFilterType[];
  prevSelectedBrandIds: number[];
  handleBrandFilterChanged: (brandIds: number[]) => void;
}

export default function BrandFilter(props: Readonly<BrandFilterProps>) {
  const { t: translate } = useTranslation();
  const { brandList, prevSelectedBrandIds, handleBrandFilterChanged } = props;

  const [filteredBrandList, setFilteredBrandList] =
    useState<BrandFilterType[]>(brandList);

  const handleOnSearch = (searchValue: string) => {
    const filteredBrands = brandList.filter(
      b =>
        b.brandName
          .toLocaleLowerCase()
          .includes(searchValue.toLocaleLowerCase()) ||
        prevSelectedBrandIds.includes(b.brandId),
    );
    setFilteredBrandList(filteredBrands);
  };

  useEffect(() => setFilteredBrandList(brandList), [brandList]);
  return (
    <CheckboxFilter
      title={translate(resources.filters.brand)}
      filterItems={mapToBrandFilterItems(
        filteredBrandList,
        prevSelectedBrandIds,
      )}
      handleOnClick={handleBrandFilterChanged}
      handleSearch={handleOnSearch}
    />
  );
}
